import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChangePassword, Company, EmployeeData,  EmployeeProfileData,  Medium,  Message } from '../models/domain';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private httpClient: HttpClient) {}

  // PROFILE API'S
  
  public getEmployeeProfile(): Observable<EmployeeProfileData> {
    return this.httpClient.get<EmployeeProfileData>(`/api/profile/v1`);
  }

  public upsertEmployeeProfile(id: number, profile: EmployeeProfileData): Observable<Message> {
    return this.httpClient.put<Message>(`/api/profile/v1/${id}`, profile);
  }

  public upsertCompanyProfile(id: number, profile: Company): Observable<Message> {
    return this.httpClient.put<Message>(`/api/profile/v1/company/${id}`, profile);
  }
  
  public upsertPassword(changePassword: ChangePassword): Observable<Message> {
    return this.httpClient.put<Message>('/api/profile/v1/change-password',changePassword)
  }

  public getCompanyProfile(): Observable<Company> {
    return this.httpClient.get<Company>(`/api/profile/v1/company`);
  }
}
